import { render } from "./BaloonPlayer.vue?vue&type=template&id=64c2d1f2&scoped=true"
import script from "./BaloonPlayer.vue?vue&type=script&lang=js"
export * from "./BaloonPlayer.vue?vue&type=script&lang=js"

import "./BaloonPlayer.vue?vue&type=style&index=0&id=64c2d1f2&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64c2d1f2"]])

export default __exports__